import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";

export class TrailingImage extends Phaser.GameObjects.Container {

    private mainImage: Phaser.GameObjects.Image;
    private nextCreationX: number;
    private nextCreationXDelta: number;
    private frame: string;

    constructor(scene: Phaser.Scene, x: number, y: number, frame: string) {

        super(scene);

        this.scaleY = GameVars.scaleY;
        
        this.frame = frame;

        this.mainImage = new Phaser.GameObjects.Image(this.scene, x, y * (1 / GameVars.scaleY), "texture_atlas_1", frame);
        this.mainImage.setScale(0.001, 0.001 );
        this.mainImage.setOrigin(0, .5);
        this.add(this.mainImage);

        this.nextCreationX = 0;
        this.nextCreationXDelta = GameConstants.GAME_WIDTH * .025;
    }

    public start(): Phaser.Tweens.Tween {

        const tween = this.scene.tweens.add({
            targets: [this.mainImage],
            x: 1200,
            scaleX: 2,
            scaleY: 2,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 1350,
            onUpdate: () => {

                if (this.mainImage.x > this.nextCreationX && this.mainImage.x < GameConstants.GAME_WIDTH) {

                    const image1 = new Phaser.GameObjects.Image(this.scene, this.nextCreationX, this.mainImage.y, "texture_atlas_1", this.frame);
                    image1.setScale(this.mainImage.scaleX, this.mainImage.scaleY);
                    image1.setOrigin(0, .5);
                    this.add(image1);

                    this.scene.tweens.add({
                        targets: [image1],
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 600,
                        alpha: 0
                    });

                    this.nextCreationX += this.nextCreationXDelta;
                    this.nextCreationXDelta *= 1.5;
                }
            }
        });

        this.nextCreationX = this.nextCreationXDelta;

        return tween;
    }
}
